<template>
  <product-content-block
    v-if="productOrigin"
    class="product-origin"
    :show-carousel="showCarousel"
    :show-title="showTitle"
    :fallback-image="fallbackImage"
    :headline="productOrigin.displayName"
    :subline="productOrigin.subtitle"
    :text="productOrigin.shortDescription"
    :link1-text="productOrigin.linkText"
    :link1-url="productOrigin.linkUrl"
    :link2-text="productOrigin.linkText2"
    :link2-url="productOrigin.linkUrl2"
    :images="productOrigin.images"
    :videos="productOrigin.videos"
    type="origin"
    read-more-target-class="product-details__headline--product-origin"
    :use-read-more="useReadMore"
  />
</template>

<script lang="ts">
  import {defineComponent} from 'vue';
  import ProductContentBlock from '../../components/productContentBlock/productContentBlock.vue';
  import productStore from '../../stores/product/ProductStore';
  import type ProductContent from '../../types/ProductContent';
  import {ProductDetailsSectionMixin} from '../../utilities/vueMixins/productDetailsSectionMixin/productDetailsSectionMixin';

  export default defineComponent({
    name: 'ProductOrigin',
    components: {
      ProductContentBlock
    },
    mixins: [ProductDetailsSectionMixin],
    props: {
      showCarousel: {
        type: Boolean,
        default: false
      },
      showTitle: {
        type: Boolean,
        default: true
      },
      fallbackImage: {
        type: String,
        required: true
      },
      useReadMore: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      productOrigin(): ProductContent {
        const hide = !productStore.productOrigin || !productStore.productOrigin.set;
        this.hideContainer(hide);
        return productStore.productOrigin;
      }
    }
  });

</script>
